import { ComputeFieldComponent } from "../computeFields";
import { Collector } from "../types";

export const CollectorNameCF: ComputeFieldComponent<
  Pick<
    Collector,
    | "collectionneursDescriptionNom"
    | "collectionneursDescriptionPrenom"
    | "collectionneursDescriptionCollectionPublique"
  > &
    Partial<Pick<Collector, "collectionneursDescriptionVille">> & {
      showCity?: boolean;
    }
> = ({ input }) => {
  const base = input.collectionneursDescriptionCollectionPublique ? (
    <>{input.collectionneursDescriptionNom ?? ""} </>
  ) : (
    <>
      {input.collectionneursDescriptionPrenom && (
        <>{input.collectionneursDescriptionPrenom} </>
      )}
      {input.collectionneursDescriptionNom && (
        <>{input.collectionneursDescriptionNom} </>
      )}
    </>
  );

  return (
    <>
      {base}
      {input.collectionneursDescriptionVille && (input.showCity ?? false) && (
        <>({input.collectionneursDescriptionVille})</>
      )}
    </>
  );
};
